import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseMaintenanceWorkflowValidDiagnosticEntriesProps<T> = {
  workflowId: string | undefined;
  filters?: {
    search?: string;
    page?: number;
  };
  mapper?: (data: any) => T;
}

export const useMaintenanceWorkflowValidDiagnosticEntries = <T,>({
  workflowId,
  filters: { search = '', page = 1 } = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceWorkflowValidDiagnosticEntriesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceWorkflowValidDiagnosticEntries', workflowId, search, page],
    queryFn: () => {
      return privateAxios.get(`/maintenance/workflows/${workflowId}/valid_diagnostic_entries`, {
        params: {
          search,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest }
}
